// WHAT: Shared types and context for notifications
// WHY:  Keep React components in .tsx file only for fast-refresh rule

import { createContext } from "react";

/**
 * @public
 *
 */
// eslint-disable-next-line import/no-unused-modules -- Reason: This interface is exported for external use and type checking, even if not directly imported in other modules.
export interface NotificationContextValue {
  /** Number of unread notifications */
  unread: number;
}

export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined);
